import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardRefreshService {

  /**
   * Supplier Requests widget refresh
   */
  private supplierRequestsRefresh$ = new Subject<void>();

  triggerSupplierRequestsRefresh(): void {
    this.supplierRequestsRefresh$.next();
  }

  onSupplierRequestsRefresh(): Observable<void> {
    return this.supplierRequestsRefresh$.asObservable();
  }

  /**
   * (Future-proofing)
   * Add more widget refresh channels here as needed
   *
   * Example:
   * private inventoryRefresh$ = new Subject<void>();
   */
}
``
